import { PropsWithChildren, FunctionComponent } from "react";
import Flex from "../flex";

interface HeadingContainerProps extends PropsWithChildren {
  withProgressBar: boolean;
  paneVariant: "form" | "optionForm" | "vector" | "list";
}

const HeadingContainer: FunctionComponent<HeadingContainerProps> = ({
  withProgressBar,
  paneVariant,
  children,
}: HeadingContainerProps) => {
  const marginBottom =
    paneVariant === "form" ? "24px" : paneVariant === "optionForm" || paneVariant === "vector" ? "40px" : "32px";
  return (
    <Flex
      $flexDirection="column"
      $flexGap={8}
      $marginTop={withProgressBar ? "24px" : "8px"}
      $marginBottom={marginBottom}
    >
      {children}
    </Flex>
  );
};

export default HeadingContainer;
